var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-container",style:({ backgroundColor: _vm.hex2rgba(_vm.color) })},[_c('font-awesome-icon',{staticClass:"icon-display",style:({ color: _vm.color }),attrs:{"icon":['fad', _vm.icon]}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }